<template>
  <div v-if="IsReady" class="order-detail">
    <el-collapse v-model="activeNames" class="order-detail__collapse">
      <el-collapse-item :title="$t('shopping.label.orderDetail')" name="orderDetail">
        <div class="order-detail__table-wrapper">
          <el-table :data="ShoppingData.shoppings" class="order-detail__table">
            <el-table-column
              prop="courseName"
              :label="$t('common.column.courseName')"
              min-width="150"
            />

            <el-table-column
              :label="$t('course.label.totalLessons')"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.courseType === 2 ? scope.row.classCount :  '-' }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('course.label.originalPrice')"
              width="120"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row.courseOriPrice | toCurrency }}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('course.label.specialPrice')"
              width="120"
              align="right"
            >
              <template slot-scope="scope">
                {{ scope.row.coursePrice | toCurrency }}
              </template>
            </el-table-column>

            <el-table-column
              v-if="step === 0"
              :label="$t('common.button.delete')"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  circle
                  @click="Delete(scope.row.courseId, scope.row.courseName)"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 折扣選擇 -->
        <div v-if="step === 0" class="order-detail__discount">
          <div class="order-detail__discount-wrapper">
            <!-- 左側:一般折扣選項 -->
            <div class="order-detail__discount-left">
              <template v-for="(item, index) in discountList">
                <div
                  v-if="item.discountMode !== 2"
                  :key="index"
                  class="order-detail__discount-item"
                >
                  <el-radio
                    v-model="chooseIndex"
                    :label="index"
                    class="form-radio"
                    @change="ChooseCode(index)"
                  >
                    {{ item.discountMode === 0 ? item.discountName : '' }}
                    {{ item.discountMode === 1 ? $t('shopping.label.allStoreDiscount') + item.discountName : '' }}
                  </el-radio>
                </div>
              </template>
            </div>

            <!-- 右側:折扣碼輸入區 -->
            <div class="order-detail__discount-right">
              <template v-for="(item, index) in discountList">
                <div v-if="item.discountMode === 2" :key="index" class="order-detail__discount-code">
                  <div class="order-detail__discount-code-header">
                    <el-radio
                      v-model="chooseIndex"
                      :label="-1"
                      class="form-radio"
                      @change="ChooseCode(-1)"
                    >
                      {{ $t('shopping.button.useDiscountCode') }}
                    </el-radio>
                  </div>
                  <div v-if="chooseIndex === -1" class="order-detail__code-input-wrapper">
                    <el-input
                      v-model="inputCode"
                      :placeholder="$t('shopping.placeholder.discountCode')"
                      :disabled="useCode"
                      size="large"
                      class="order-detail__code-input"
                    />
                    <el-button
                      :type="useCode ? 'danger' : 'success'"
                      :icon="useCode ? 'el-icon-delete' : 'el-icon-check'"
                      size="large"
                      class="order-detail__code-button"
                      @click="UseCode()"
                    >
                      {{ useCode ? $t('common.button.remove') : $t('shopping.button.useDiscountCode') }}
                    </el-button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- 小計 -->
        <div class="order-detail__summary">
          <div class="order-detail__summary-content">
            <div class="order-detail__summary-row">
              <span class="order-detail__summary-label">{{ $t('shopping.label.subtotal') }}</span>
              <span class="order-detail__summary-value">{{ $t('common.currency.ntd') }} {{ subtotalPrice | toCurrency }}</span>
            </div>
            <div class="order-detail__summary-row">
              <span class="order-detail__summary-label">{{ $t('shopping.label.discount') }}</span>
              <span v-if="discountValid" class="order-detail__summary-value order-detail__summary-value--discount">
                -{{ $t('common.currency.ntd') }} {{ discountPrice | toCurrency }}
              </span>
              <span v-else class="order-detail__summary-label">{{ $t('shopping.label.discountNotMet') }}</span>
            </div>
            <div class="order-detail__summary-row order-detail__summary-row--total">
              <span class="order-detail__summary-label">{{ $t('shopping.label.total') }}</span>
              <span class="order-detail__summary-value order-detail__summary-value--total">
                {{ $t('common.currency.ntd') }} {{ totalPrice | toCurrency }}
              </span>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { GetDiscountList, GetDiscountDetail } from '@/api/ShoppingCartApi';

export default {
  props: ['step', 'ShoppingData', 'IsReady', 'backTotalPrice'],
  data() {
    return {
      // totalPrice: 0,
      // subtotalPrice: 0,
      // discountPrice: 0,

      // 折扣選項
      discountList: [],

      // 目前折扣的選擇 -1:是使用折扣碼
      chooseIndex: 0,
      // 使用折扣碼  true表示已經鎖定
      useCode: false,
      // 輸入的折扣碼
      inputCode: '',
      // 使用折扣碼的折扣資料
      UserDiscountData: {
        discountId: 0,
        discountMode: 0,
        discountName: '',
        discountCode: '',
        discountType: 0,
        discountPrice: 0,
        discountPercent: 0,
        discountMoney: 0,
      },
      CurrentDiscountData: {
        discountId: 0,
        discountMode: 0,
        discountName: '',
        discountCode: '',
        discountType: 0,
        discountPrice: 0,
        discountPercent: 0,
        discountMoney: 0,
      },

      activeNames: this.step === 0 ? 'orderDetail' : '',
    };
  },
  watch: {
    // 等購物車資料準備好
    async IsReady() {
      if (this.IsReady === true) {
        this._.merge(
          this.CurrentDiscountData,
          this._.pick(this.ShoppingData, this._.keys(this.CurrentDiscountData)),
        );

        if (this.step === 0) await this.GetDiscountList();

        if (this.ShoppingData.discountMode === 1) {
          const index = this._.findIndex(this.discountList, {
            discountCode: this.ShoppingData.discountCode,
          });
          if (index > -1) this.chooseIndex = index;
        }

        if (this.ShoppingData.discountMode === 2) {
          this._.merge(
            this.UserDiscountData,
            this._.pick(this.ShoppingData, this._.keys(this.UserDiscountData)),
          );
          this.chooseIndex = -1;
          this.useCode = true;
          this.inputCode = this.UserDiscountData.discountCode;
        }
      }
    },
  },
  computed: {
    // 小計金額
    subtotalPrice() {
      return this._.reduce(this.ShoppingData.shoppings, (sum, item) => sum + item.coursePrice, 0);
    },
    // 折扣金額
    discountPrice() {
      let discount = 0;
      if (this.ShoppingData.discountType === 1) {
        if (this.subtotalPrice >= this.ShoppingData.discountPrice) {
          discount = this.ShoppingData.discountMoney;
        }
      } else if (this.ShoppingData.discountType === 2) {
        if (this.subtotalPrice >= this.ShoppingData.discountPrice) {
          const val = this.ShoppingData.discountPercent / 100;
          const val2 = Math.ceil(this.subtotalPrice * val);
          discount = this.subtotalPrice - val2;
        }
      }
      return discount;
    },
    // 總金額
    totalPrice() {
      this.$emit('update:backTotalPrice', this.subtotalPrice - this.discountPrice);
      return this.subtotalPrice - this.discountPrice;
    },
    // 使否達到折扣條件
    discountValid() {
      if (this.chooseIndex === 0) return true;
      if (this.UserDiscountData.discountId === 0 && this.chooseIndex === -1) return true;
      if (this.discountPrice > 0) return true;
      this.ClearDiscount();
      this.$emit('update:ShoppingData', this.ShoppingData);
      return false;
    },
  },
  methods: {
    // 明細展開
    ToggleClass(event) {
      if (
        // eslint-disable-next-line operator-linebreak
        event.target.className !== 'fa fa-trash fa-lg text-danger' &&
        event.target.className !== 'btn'
      ) {
        event.currentTarget.parentElement.classList.toggle('active');
      }
    },
    // 設定目前選擇的折扣到購物車資料
    ChooseCode(index) {
      let disCountData = {};
      if (index === -1) disCountData = this._.cloneDeep(this.UserDiscountData);
      else disCountData = this._.cloneDeep(this.discountList[index]);
      this._.merge(this.ShoppingData, disCountData);
      this._.merge(this.CurrentDiscountData, disCountData);
      this.$emit('update:ShoppingData', this.ShoppingData);
    },
    // 清除購物車資料中的折扣資料
    ClearDiscount() {
      const disCountData = {
        discountId: 0,
        discountMode: 0,
        discountName: '',
        discountCode: '',
        discountType: 0,
        discountPrice: 0,
        discountPercent: 0,
        discountMoney: 0,
      };
      this._.merge(this.ShoppingData, disCountData);
      this.$emit('update:ShoppingData', this.ShoppingData);
    },
    // 使用折扣碼
    UseCode() {
      if (this.useCode === true) {
        this.inputCode = '';
        this.useCode = false;
        this.UserDiscountData.discountId = 0;
        if (this.chooseIndex === -1) this.ClearDiscount();
      } else {
        this.GetDiscountDetail(this.inputCode);
      }
    },
    // 取得折扣選項
    GetDiscountList() {
      return GetDiscountList().then((response) => {
        if (response.data.statusCode === 0) {
          this.discountList = response.data.data;
        }
      });
    },
    // 取得折扣碼資料
    GetDiscountDetail(code) {
      GetDiscountDetail(code).then((response) => {
        if (response.data.statusCode === 0) {
          if (response.data.data === null) {
            this.$message({
              type: 'error',
              message: this.$t('shopping.message.invalidDiscountCode'),
            });
          } else {
            this.useCode = true;
            this.UserDiscountData = this._.cloneDeep(response.data.data);
            this.ChooseCode(-1);
          }
        }
      });
    },
    Delete(id, name) {
      this.$emit('pushDelete', id, name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.order-detail {
  margin: 24px 0;

  &__collapse {
    border: 1px solid var(--border-light);
    border-radius: var(--border-radius-lg);
    overflow: hidden;

    /deep/ .el-collapse-item__header {
      font-weight: 600;
      background-color: var(--background-light);
      padding: 20px 24px;
      font-size: var(--font-size-lg);
      color: var(--text-primary);
      border-bottom: 1px solid var(--border-light);
      transition: all var(--transition-fast);

      &.is-active {
        background-color: var(--background-white);
      }

      &:hover {
        background-color: var(--background-white);
      }
    }

    /deep/ .el-collapse-item__wrap {
      border-bottom: none;
    }

    /deep/ .el-collapse-item__content {
      padding: 24px;
      background-color: var(--background-white);
    }
  }

  &__table-wrapper {
    margin-bottom: 24px;
  }

  &__table {
    /deep/ .el-table__header th {
      background-color: var(--background-base);
      color: var(--text-primary);
      font-weight: 600;
      font-size: var(--font-size-sm);
    }

    /deep/ .el-table__row {
      transition: background-color var(--transition-fast);

      &:hover {
        background-color: var(--primary-light-color);
      }
    }
  }

  &__discount {
    margin: 32px 0;
    padding: 24px;
    background-color: var(--background-light);
    border-radius: var(--border-radius-base);

    @media (max-width: $breakpoint-sm) {
      padding: 20px;
      margin: 24px 0;
    }
  }

  &__discount-wrapper {
    display: flex;
    gap: 32px;
    justify-content: space-between;
    align-items: flex-start;

    @media (max-width: 991px) {
      flex-direction: column;
      gap: 24px;
    }
  }

  &__discount-left {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 200px;

    @media (max-width: 991px) {
      min-width: 0;
      width: 100%;
    }
  }

  &__discount-right {
    flex: 1;
    min-width: 0;
    max-width: 500px;

    @media (max-width: 991px) {
      width: 100%;
    }
  }

  &__discount-code {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__discount-code-header {
    display: flex;
    align-items: center;
  }

  &__code-input-wrapper {
    display: flex;
    gap: 12px;
    align-items: stretch;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }
  }

  &__code-input {
    flex: 1;
    min-width: 0;

    /deep/ .el-input__inner {
      height: 44px;
      line-height: 44px;
      font-size: var(--font-size-base);
      border: 2px solid var(--border-base);
      border-radius: var(--border-radius-base);
      transition: all var(--transition-fast);

      &:focus {
        border-color: var(--primary-color);
        box-shadow: 0 0 0 3px rgba(0, 171, 235, 0.1);
      }

      &:disabled {
        background-color: var(--background-light);
        cursor: not-allowed;
      }

      @media (max-width: 768px) {
        height: 42px;
        line-height: 42px;
      }
    }
  }

  &__code-button {
    flex-shrink: 0;
    min-width: 120px;
    height: 44px;
    font-weight: 600;
    font-size: var(--font-size-base);
    border-radius: var(--border-radius-base);
    transition: all var(--transition-fast);

    &.el-button--success {
      background-color: #67C23A;
      border-color: #67C23A;

      &:hover {
        background-color: #85CE61;
        border-color: #85CE61;
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }

    &.el-button--danger {
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(245, 108, 108, 0.3);
      }

      &:active {
        transform: translateY(0);
      }
    }

    @media (max-width: 768px) {
      width: 100%;
      height: 42px;
    }
  }

  &__summary {
    margin-top: 32px;
    padding: 24px;
    background-color: #f4f4f4;
    border-radius: var(--border-radius-base);
    display: flex;
    justify-content: flex-end;
  }

  &__summary-content {
    width: 100%;
    max-width: 400px;

    @media (max-width: $breakpoint-sm) {
      max-width: 100%;
    }
  }

  &__summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--border-lighter);

    &:last-child {
      border-bottom: none;
    }

    &--total {
      margin-top: 12px;
      padding-top: 16px;
      border-top: 2px solid var(--border-base);
    }
  }

  &__summary-label {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    font-weight: 600;

    .order-detail__summary-row--total & {
      font-size: var(--font-size-xl);
      font-weight: 700;
      color: var(--text-price);
    }
  }

  &__summary-value {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    font-weight: 500;

    &--total {
      font-size: var(--font-size-xl);
      font-weight: 700;
      color: var(--text-price);
    }
  }
}
</style>
